"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyleType4b = exports.StyleType4a = exports.StyleType3b = exports.StyleType3a = exports.StyleType2b = exports.StyleType2a = exports.StyleType1b = exports.StyleType1a = void 0;
var styled_components_1 = require("@empiriecom/module-components/utils/styled-components");
var boxTypes_1 = require("./boxTypes");
exports.StyleType1a = styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n\n  right: 50%;\n  @media only screen and (min-width: ", ") {\n    right: 55%;\n  }\n\n  transform-origin: ", ";\n"], ["\n  ", "\n\n  right: 50%;\n  @media only screen and (min-width: ", ") {\n    right: 55%;\n  }\n\n  transform-origin: ",
    ";\n"])), boxTypes_1.BoxSizeSmall, function (_a) {
    var tabletMinWidth = _a.tabletMinWidth;
    return tabletMinWidth;
}, function (_a) {
    var styleVerticalAlignment = _a.styleVerticalAlignment;
    if (styleVerticalAlignment === 'top') {
        return 'top right';
    }
    if (styleVerticalAlignment === 'bottom') {
        return 'bottom right';
    }
    return 'right';
});
exports.StyleType1b = styled_components_1.css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  ", "\n\n  left: 50%;\n  @media only screen and (min-width: ", "}) {\n    left: 55%;\n  }\n\n  transform-origin: ", ";\n"], ["\n  ", "\n\n  left: 50%;\n  @media only screen and (min-width: ", "}) {\n    left: 55%;\n  }\n\n  transform-origin: ",
    ";\n"])), boxTypes_1.BoxSizeSmall, function (_a) {
    var tabletMinWidth = _a.tabletMinWidth;
    return tabletMinWidth;
}, function (_a) {
    var styleVerticalAlignment = _a.styleVerticalAlignment;
    if (styleVerticalAlignment === 'top') {
        return 'top left';
    }
    if (styleVerticalAlignment === 'bottom') {
        return 'bottom left';
    }
    return 'left';
});
exports.StyleType2a = styled_components_1.css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  ", "\n  left: 0;\n  transform-origin: ", ";\n"], ["\n  ", "\n  left: 0;\n  transform-origin: ",
    ";\n"])), boxTypes_1.BoxSizeMedium, function (_a) {
    var styleVerticalAlignment = _a.styleVerticalAlignment;
    if (styleVerticalAlignment === 'top') {
        return 'top left';
    }
    if (styleVerticalAlignment === 'bottom') {
        return 'bottom left';
    }
    return 'left';
});
exports.StyleType2b = styled_components_1.css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  ", "\n  right: 0;\n  transform-origin: ", ";\n"], ["\n  ", "\n  right: 0;\n  transform-origin: ",
    ";\n"])), boxTypes_1.BoxSizeMedium, function (_a) {
    var styleVerticalAlignment = _a.styleVerticalAlignment;
    if (styleVerticalAlignment === 'top') {
        return 'top right';
    }
    if (styleVerticalAlignment === 'bottom') {
        return 'bottom right';
    }
    return 'right';
});
exports.StyleType3a = styled_components_1.css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  ", "\n  left: 5%;\n  transform-origin: ", ";\n"], ["\n  ", "\n  left: 5%;\n  transform-origin: ",
    ";\n"])), boxTypes_1.BoxSizeSmall, function (_a) {
    var styleVerticalAlignment = _a.styleVerticalAlignment;
    if (styleVerticalAlignment === 'top') {
        return 'top left';
    }
    if (styleVerticalAlignment === 'bottom') {
        return 'bottom left';
    }
    return 'left';
});
exports.StyleType3b = styled_components_1.css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  ", "\n  right: 5%;\n  transform-origin: ", ";\n"], ["\n  ", "\n  right: 5%;\n  transform-origin: ",
    ";\n"])), boxTypes_1.BoxSizeSmall, function (_a) {
    var styleVerticalAlignment = _a.styleVerticalAlignment;
    if (styleVerticalAlignment === 'top') {
        return 'top right';
    }
    if (styleVerticalAlignment === 'bottom') {
        return 'bottom right';
    }
    return 'right';
});
exports.StyleType4a = styled_components_1.css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  ", "\n\n  left: 5%;\n  @media only screen and (min-width: ", "}) {\n    left: 2%;\n  }\n\n  transform-origin: ", ";\n"], ["\n  ", "\n\n  left: 5%;\n  @media only screen and (min-width: ", "}) {\n    left: 2%;\n  }\n\n  transform-origin: ",
    ";\n"])), boxTypes_1.BoxSizeMedium, function (_a) {
    var tabletMinWidth = _a.tabletMinWidth;
    return tabletMinWidth;
}, function (_a) {
    var styleVerticalAlignment = _a.styleVerticalAlignment;
    if (styleVerticalAlignment === 'top') {
        return 'top left';
    }
    if (styleVerticalAlignment === 'bottom') {
        return 'bottom left';
    }
    return 'left';
});
exports.StyleType4b = styled_components_1.css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  ", "\n\n  right: 5%;\n  @media only screen and (min-width: ", "}) {\n    right: 2%;\n  }\n\n  transform-origin: ", ";\n"], ["\n  ", "\n\n  right: 5%;\n  @media only screen and (min-width: ", "}) {\n    right: 2%;\n  }\n\n  transform-origin: ",
    ";\n"])), boxTypes_1.BoxSizeMedium, function (_a) {
    var tabletMinWidth = _a.tabletMinWidth;
    return tabletMinWidth;
}, function (_a) {
    var styleVerticalAlignment = _a.styleVerticalAlignment;
    if (styleVerticalAlignment === 'top') {
        return 'top right';
    }
    if (styleVerticalAlignment === 'bottom') {
        return 'bottom right';
    }
    return 'right';
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8;
//# sourceMappingURL=styleTypes.js.map